import React, { Component } from 'react';
import Gravatar from 'react-gravatar';
import ModalServices from './ModalServices';
import ModalAvailability from './ModalAvailability';
import ModalAccept from './ModalAccept';
import ModalCancel from './ModalCancel';

class BookingTableRow extends Component {
    constructor(props){
        super(props);
        this.state = {
            starred:false
        }
        this.onClick = this.onClick.bind(this);
        this.qHandlerClick = this.qHandlerClick.bind(this);
    }


    qHandlerClick(event, booking){
        event.preventDefault();
        this.props.qHandler(booking);
    }

    onClick(event, component, title){
        event.preventDefault();
        this.props.handler(this.props.booking, component, title);
    }


  render() {
      var dt_class = 'avatar bg-success';
      if (this.props.booking.days_until < 7){
          dt_class = 'avatar bg-danger';
      }

    return (
            <tr className="media align-items-center pt-0 cursor-pointer" onClick={(event) => this.qHandlerClick(event, this.props.booking)}>
              <td style={{width:3+"%"}}>
                  <label className="toggler fs-16 pl-12 d-none d-md-block">
                    <input type="checkbox" name="starred" checked={this.state.starred}/>
                    <i className="fa fa-star"></i>
                  </label>
              </td>
              <td style={{width:27+"%"}}>
                  <a className="flexbox align-items-center flex-grow gap-items mt-20">
                    <Gravatar email={this.props.booking.email} size={36} rating="pg" default="identicon" className="avatar" />
                    <div className="media-body text-truncate">
                      <h6>{this.props.booking.full_name}</h6>
                      <small>
                        <span>{this.props.booking.email}</span>
                        <span className="divider-dash">{this.props.booking.phone}</span>
                      </small>
                    </div>
                </a>
              </td>
              <td style={{width:25+"%"}} className="media">
                <span className={dt_class}>{this.props.booking.days_until}</span>
                <div className="media-body text-truncate">
                  <h6 className="mb-0">{this.props.booking.date}</h6>
                  <small>
                    <span>Ready by {this.props.booking.ready_time}</span>
                  </small>
                </div>
              </td>
              <td style={{width:30+"%"}} className="media">
                <span className="avatar bg-info">{this.props.booking.distance}</span>
                <div className="media-body text-truncate">
                  <h6 className="text-truncate">{this.props.booking.location_name}</h6>
                  <small>
                    <span>{this.props.booking.address}</span>
                  </small>
                </div>
              </td>
              <td style={{width:15+"%"}}>
                <span className="lead text-fade mr-25 d-none d-md-block pull-right" title="Service Total" data-provide="tooltip">${this.props.booking.service_total}</span>
              </td>
              <td style={{width:1+"%"}}>
                  <div className="dropdown">
                    <a className="text-lighter" href="#" data-toggle="dropdown"><i className="ti-more-alt rotate-90"></i></a>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" href="#" onClick={(event) => this.onClick(event, ModalServices, "Requested Services")}><i className="fa fa-fw fa-scissors"></i> Requested Services</a>
                      <a className="dropdown-item" href="#" onClick={(event) => this.onClick(event, ModalAvailability, "Availability for " + this.props.booking.date + " @ " + this.props.booking.ready_time)}><i className="fa fa-fw fa-calendar"></i> Assign Artists</a>
                      <a className="dropdown-item" href={"mailto:" + this.props.booking.email}><i className="fa fa-fw fa-envelope"></i> Message</a>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#" onClick={(event) => this.onClick(event, ModalCancel, "Cancel Inquiry")}><i className="fa fa-fw fa-trash"></i> Mark Inactive</a>
                    </div>
                  </div>
              </td>
             </tr>
        );
    }
}

export default BookingTableRow;



// WEBPACK FOOTER //
// ./src/components/business/BookingTableRow.js